__webpack_require__.p = "https://static.bigbrain.gg/dev/lol/";